import { render, staticRenderFns } from "./ractice.vue?vue&type=template&id=046a58a9&scoped=true&"
import script from "./ractice.vue?vue&type=script&lang=js&"
export * from "./ractice.vue?vue&type=script&lang=js&"
import style0 from "./ractice.vue?vue&type=style&index=0&id=046a58a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046a58a9",
  null
  
)

export default component.exports